import FontIconButton from '@atom/components/common/FontIconButton';
import { CheckIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { AttributesType } from '@atom/types/schema';

import classes from '../formBuilder.module.css';

const styles = {
  icon: {
    padding: '0px',
    marginLeft: '0.5rem',
    height: '35px',
    width: '35px',
  },
};

interface Props {
  fullAttribute: AttributesType;
  isAttributeChecked: boolean;
  selectAll: boolean;
  fieldId: string;
  schemaId: string;
  attributeGroupName: string;
  updateAttribute: (
    fieldId: string,
    schemaId: string,
    addAttribute: boolean,
    attributeGroupName: string,
    attribute: AttributesType,
  ) => void;
}

const AttributeBlock = ({
  isAttributeChecked: checked,
  updateAttribute,
  fieldId,
  schemaId,
  attributeGroupName,
  fullAttribute,
}: Props) => {
  const toggleCheck = () => {
    const addAttribute = !checked;
    updateAttribute(
      fieldId,
      schemaId,
      addAttribute,
      attributeGroupName,
      fullAttribute,
    );
  };

  const color = checked ? colors.brand.blue : colors.neutral.gray;
  const backgroundColor = checked ? colors.neutral.ash : colors.neutral.typhoon;

  return (
    <div
      className={classes.attributeBlock}
      style={{ backgroundColor }}
      onClick={toggleCheck}
    >
      <div>{fullAttribute.name}</div>
      <FontIconButton
        style={styles.icon}
        onClick={toggleCheck}
        color={color}
        icon={CheckIcon}
      />
    </div>
  );
};

export default AttributeBlock;
